/* globals ChildNode */

export const smartTruncateHtml = (inputHtml: string, maxLength: number): string => {
  if (typeof DOMParser == 'undefined') {
    // console.warn('DOMParser is undefined. Not truncating');
    return inputHtml;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(inputHtml, 'text/html');
  let currentLength = 0;

  const truncateNode = (node: ChildNode) => {
    if (currentLength >= maxLength) {
      node.remove();
      return;
    }

    if (node.nodeType === Node.TEXT_NODE) {
      const textContent = node.textContent || '';
      const remainingLength = maxLength - currentLength;

      if (textContent.length + currentLength > maxLength) {
        node.textContent = textContent.slice(0, remainingLength - 1) + '…';
        currentLength = maxLength;
      } else {
        currentLength += textContent.length;
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      const children = Array.from(node.childNodes);
      for (const child of children) {
        truncateNode(child);
      }
    }
  };

  truncateNode(doc.body);
  return doc.body.innerHTML;
};
